module.exports = __webpack_public_path__ + "img/diamond_chart.7cb6734f.png";